import AppAssets from "@toothfairy/shared-ui/AppAssets";
import { AppText } from "@toothfairy/shared-ui";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { useHistory } from "../../Router";
import React from "react";
import { View } from "react-native";

const MFARequiredScreen = () => {
  const { currentTheme } = AppTheme.useTheme();
  const { dispatch } = AppStateManager.useAppStateManager();
  const history = useHistory();
  return (
    <View
      style={{
        width: "50%",
        height: "50%",
        marginVertical: "auto",
        marginHorizontal: "auto",
        alignItems: "center",
      }}
    >
      <AppPlaceholderView
        wrapperStyle={{
          height: "auto",
          paddingBottom: 20,
        }}
        size={30}
        color={currentTheme?.theme?.red}
        icon={AppAssets.icons.lock}
        mainCaption="MFA required to access this workspace"
        mainCaptionStyle={{
          fontSize: currentTheme?.theme?.large_font_size,
        }}
        subCaption="Two-factor authentication is required to access this workspace. Please enable MFA in your account settings."
        subCaptionStyle={{
          fontSize: currentTheme?.theme?.medium_font_size,
          marginTop: 10,
          textAlign: "center",
        }}
      />
      <View style={{ flexDirection: "row", gap: 20, marginTop: 20 }}>
        <AppText
          isClickable
          isHoverable={false}
          style={{
            textDecoration: "underline",
            color: currentTheme?.theme?.primary,
            fontFamily: "boldFont",
          }}
          onPress={() => {
            dispatch("SET_PAGE_NOT_FOUND", false);
            history.push("/profile/profile_settings");
          }}
        >
          Go to Account Settings
        </AppText>
        <AppText
          isClickable
          isHoverable={false}
          style={{
            textDecoration: "underline",
            color: currentTheme?.theme?.primary,
            fontFamily: "boldFont",
          }}
          onPress={() => {
            dispatch("SET_PAGE_NOT_FOUND", false);
            history.push("/workspaces");
          }}
        >
          Back to Workspaces
        </AppText>
      </View>
    </View>
  );
};

export default MFARequiredScreen;
